export default __webpack_public_path__ + "static/medgas_outlet_b.a0f5f7c79aa8cd5c1e033e8ba22f7679.png";